import FormValidation from "../../Validation/FormValidation";

const Email = {
    pattern: /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z0-9][a-z0-9-]*[a-z0-9]$/i,

    bind(form) {
        this.input = 'input[type="email"]';
        form.find(this.input).on('keyup change paste', (evt) => {
            FormValidation.setValid($(evt.currentTarget), this.isValid($(evt.currentTarget)));
        });
    },

    check(form) {
        let ok = true;
        form.find(this.input).each((i, el) => {
            ok &= this.isValid($(el));
            FormValidation.setValid($(el),  this.isValid($(el)), true);
        })
        return ok;
    },

    isValid(input) {
        const isRequired = input.closest('.input').is('.required');
        const isFilled = input.val().length > 0;

        if (isRequired || isFilled) return !!input.val().toString().match(this.pattern);
        else return true;
    },
}
export default Email;